// Runtime-конфиг стенда: window._env_ задаётся файлом /env.js (генерируется при деплое),
// фоллбэк — build-time process.env (локальная разработка, легаси-сборки).
export const getENV = (key: string): string | undefined => {
	const env = window?._env_;
	if (env && key in env) {
		return env[key];
	}
	return process.env?.[key];
};
